import { useTranslation } from "react-i18next";

const months = [1, 2, 3, 4, 5, 6];

export default function LearningSteps() {
  const { t } = useTranslation();

  return (
    <section id="learning-steps" className="relative bg-midnight py-24 md:py-36">
      <div className="w-full px-6 md:px-12 lg:px-16">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-6">
            {t("pricing.steps.tag")}
          </span>
          <h2 className="text-marble font-serif text-2xl md:text-3xl lg:text-4xl font-light tracking-wide mb-4">
            {t("pricing.steps.title")}
          </h2>
          <p className="text-marble/50 text-sm md:text-base font-sans leading-relaxed max-w-xl mx-auto whitespace-pre-line">
            {t("pricing.steps.subtitle")}
          </p>
          {t("pricing.steps.note") && (
            <p className="text-marble/40 text-xs md:text-sm font-sans leading-relaxed max-w-xl mx-auto whitespace-pre-line mt-4">
              {t("pricing.steps.note")}
            </p>
          )}
        </div>

        {/* Timeline */}
        <div className="max-w-4xl mx-auto space-y-14 md:space-y-20">
          {months.map((m, index) => (
            <div
              key={m}
              className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start"
            >
              {/* Left: label & month */}
              <div className="lg:col-span-4 flex lg:flex-col items-center lg:items-start gap-4 lg:gap-2">
                <span className="text-champagne/60 text-xs font-sans tracking-widest uppercase">
                  {t(`pricing.step${m}.label`)}
                </span>
                <div className="flex items-center gap-3">
                  <span className="text-marble font-serif text-2xl md:text-3xl font-light">
                    {t(`pricing.step${m}.month`)}
                  </span>
                  <span className="text-champagne/40 text-xs font-mono">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                {/* Connector line */}
                {index < months.length - 1 && (
                  <div className="hidden lg:block w-px h-16 bg-gradient-to-b from-champagne/30 to-transparent mt-4 ml-6" />
                )}
              </div>

              {/* Right: title & desc */}
              <div className="lg:col-span-8 lg:pl-8 lg:border-l border-white/5">
                <h3 className="text-marble font-serif text-xl md:text-2xl font-light tracking-wide mb-3">
                  {t(`pricing.step${m}.title`)}
                </h3>
                <p className="text-marble/50 text-sm md:text-base font-sans leading-relaxed whitespace-pre-line">
                  {t(`pricing.step${m}.desc`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}